module.exports = __webpack_public_path__ + "img/y-106.c78c1f2a.png";